//En este componente se muestra:
//  CalendarioSemanal - Tabla resumen de los valores de cada dia de la semana para cada zona (arcade, bolera, etc...)
//  CierreSemanalMaqArcade - Lecturas de las máquinas de arcade de la semana (input)
//  CierreSemanalArcade - Totales de arcade de la semana (input)
//  CierreSemanalTokensFondo - Variación de fondo de los tokens ¿? viene así del TCW, mirar a que se refiere exactamente (input)
//  CierreSemanalTokensCentro - Variación de fondo de los tokens del centro (input)
//  CierreSemanalEuros - Variación de fondo de Euros del centro (input)
//
// Contiene un componente CentroDia que permite seleccionar el centro y la fecha de cierre ( el centro solamente si el usuario tiene permisos ). 
// El centro y el día están guardados en el store de la aplicación.
// Se obtienen los datos mediante la acción getDatosCierreSemanal una vez hay un centro y un dia seleccionados. 
// La primera vez que se entra, se llama a la acción setCentroDia para obtener el ultimo día abierto para el centro seleccionado.
//
// Cuando se obtienen los datos de un día concreto, se llama a updateCierreSemanalBillaresDB que actualiza la información de las máquinas de billares, 
//  dividiendo la suma del total de billares introducido en esta semana (cierre diario de cada día) entre todas las máquinas de billares
//  ÚNICAMENTE si las máquinas de billares tienen los ingresos a 0
//
//El botón de guardar llama a la acción updateCierreSemanalDatosDB y hace un nextStep del Stepper de AccCierreSemanal para que se muestre el componente CierreSemanalOtrosDatos.



import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

//actions:
import { getDatosCierreSemanal, updateCierreSemanalDatosDB, resetDatosCierreSemanal, updateCierreSemanalBillaresDB } from '../../actions/cierre_semanal_actions';
import { setCentroDia } from '../../actions/centro_dia_actions';
import { openDialog } from '../../actions/index';

//components:
import CentroDia from '../centro_dia';
import CierreSemanalMaqArcade from './cierre_semanal_maq_arcade';
import CierreSemanalArcade from './cierre_semanal_arcade';
import CierreSemanalTokensFondo from './cierre_semanal_tokens_fondo';
import CierreSemanalTokensCentro from './cierre_semanal_tokens_centro';
import CierreSemanalEuros from './cierre_semanal_euros';
import CalendarioSemanal from '../../components/dialogs/cierre_semanal_calendario';

const styles = theme => ({
    root: {
        padding: '8px 24px',
        margin: theme.spacing(1),
        flexGrow: 1,
    },
    paperCaja: {
        display: 'inline-flex',
        backgroundColor: '#E8F1D7',
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: '20px 0',
        padding: 10,
    },
    paperResumen: {
        backgroundColor: theme.palette.primary.light,
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: theme.spacing(1),
        marginTop: theme.spacing(2),
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 1022
    },
    paperConcepto: {
        padding: 0,
        margin: theme.spacing(1),
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
    },
    paperZona: {
        padding: 0,
        margin: 0,
        borderRadius: '0px',
        marginBottom: 28,
    },
    titleIngresos: {
        fontSize: '15px',
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.primary.main,
        padding: '4px 2px 4px 12px',
    },
    titlePagos: {
        fontSize: '15px',
        fontWeight: '500',
        color: 'white',
        backgroundColor: theme.palette.secondary.main,
        padding: '4px 2px 4px 12px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    buttonCalendario: {
        marginTop: 'auto',
        marginBottom: 'auto',
        marginLeft: 120,
        //padding: '10px 4%',
        height: 50,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    divData: {
        position: 'relative'
    },
    divLecturas: {
        display: 'flex'
    },
    cover: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 1,
        backgroundColor: '#ddd',
        opacity: 0.3,
    },
});

class CierreSemanalDatos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false
        };
    };

    componentDidMount() {
        if (this.props.first) {
            if (this.props.centroDiaSelected.centro.id !== undefined && this.props.centroDiaSelected.dia !== '' && !this.props.centroDiaSelected.centro.isGroup) {

                this.props.setCentroDia(this.props.centroDiaSelected.centro.id, undefined, true);
            };
        }
    };

    componentDidUpdate(prevProps, prevState, snapshot) {

        var dt = new Date(this.props.centroDiaSelected.dia);

        if (prevProps.centroDiaSelected.centro !== this.props.centroDiaSelected.centro ||
            prevProps.centroDiaSelected.dia !== this.props.centroDiaSelected.dia) {
            //if (this.props.centroDiaSelected.existeCierreSemanal) {
            if(dt.getDay() === this.props.centroDiaSelected.centro.iDiaCierre) this.props.getDatosCierreSemanal(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
            // }
            // else {
            //     this.props.openDialog('SimpleMessage', {
            //         message: 'No es posible entrar datos si no están cerrados todos los días de la semana'
            //     });
            // }
        };

        if (prevProps.isLoading === true) {
            if (!this.props.isLoading) this.props.updateCierreSemanalBillaresDB(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia, this.props.datosCierreSemanal.totalBillares);
        }

        if (prevProps.isLoading !== this.props.isLoading) this.setState({ showSpinner: this.props.isLoading });

    };

    hanldeOKClick = () => {

        if (!this.props.isSemanaCerrada) {
            //update cierre diario datos data
            this.props.updateCierreSemanalDatosDB(
                this.props.datosCierreSemanal,
                this.props.centroDiaSelected.centro.id,
                this.props.centroDiaSelected.dia,
                this.props.nextStep
            );
        }
        else {
            this.props.nextStep();
        }

    };


    handleCalendario = () => {

        this.props.openDialog('CalendarioSemanal', {
            centro: this.props.centroDiaSelected.centro.id,
            fecha: this.props.centroDiaSelected.dia,
            user: this.props.user
        }, 'dialog-calendario', true, 'lg');

    }

    render() {

        const { classes } = this.props;

        const mult_reopa = (this.props.centroDiaSelected.centro.reopa - 31162) / 100;

        if (this.props.datosCierreSemanal.cajaIDgeneral === undefined && !this.state.showSpinner) {
            return (
                <div className={classes.root}>
                    <CentroDia semanal />
                </div>
            );
        }

        else if (this.state.showSpinner) {
            return (
                <div className={classes.root}>
                    <CentroDia semanal />

                    <div className={classes.spinnerContainer}>
                        <CircularProgress className={classes.spinner} color="primary" />
                    </div>
                </div>
            );
        };

        return (
            <div className={classes.root}>
                <CentroDia semanal />

                <div className={classes.divData}>
                    <div className={classes.cover} style={{ display: this.props.centroDiaSelected.isValid ? 'none' : 'block' }} ></div>

                    <div className={classes.paperResumen}>
                        <CalendarioSemanal centro={this.props.centroDiaSelected.centro.id} fecha={this.props.centroDiaSelected.dia} user={this.props.user} semanaCerrada={this.props.centroDiaSelected.isSemanaCerrada} multiplicador={mult_reopa}></CalendarioSemanal>
                    </div>

                    <div className={classes.divLecturas}>
                        <CierreSemanalMaqArcade />
                        <Button className={classes.buttonCalendario} variant="contained" color="secondary" onClick={this.handleCalendario} hidden>{'Calendario Semanal'}</Button>
                    </div>

                    <div className={classes.paperCaja}>
                        <CierreSemanalArcade />
                        <CierreSemanalTokensFondo />
                        <CierreSemanalTokensCentro />
                        <CierreSemanalEuros />
                    </div>
                </div>
                <div>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={this.hanldeOKClick} disabled={!this.props.centroDiaSelected.isValid}>
                        {this.props.isSemanaCerrada ? 'Siguiente' : 'Guardar'}
                    </Button>
                </div>

            </div>

        );

    };

};

CierreSemanalDatos.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    datosCierreSemanal: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    //dispatch
    getDatosCierreSemanal: PropTypes.func.isRequired,
    updateCierreSemanalDatosDB: PropTypes.func.isRequired,
    //parameters


};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected,
        datosCierreSemanal: state.datosCierreSemanal.datos,
        isLoading: state.datosCierreSemanal.isLoading,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDatosCierreSemanal,
        updateCierreSemanalDatosDB,
        resetDatosCierreSemanal,
        updateCierreSemanalBillaresDB,
        setCentroDia,
        openDialog
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalDatos));
